import liveFor from "./live-for";
import video from "./video";
const broad = {
	path: '/broadcast',
	name: 'broadcast',
	meta:{
		// tabBar: false,
	},
	component: resolve => require(['@/views/broadcast/broadcast.vue'], resolve),
	children:[
		...liveFor, //申请直播间

		{
			//我的直播间
			path: 'my-live',
			component: () => import("@views/broadcast/my-live"),
			meta:{
				tabBar: false,
			},
			children:[
        {
          //直播信息
          path:"message/:liveId",
          component: () => import("@views/broadcast/my-live/message"),
          meta:{
            tabBar: false,
          }

        },
			]
		},
		{
			//历史直播
			path: 'history-live/:history',
			component: () => import("@views/broadcast/history-live"),
			meta:{
				tabBar: false,
				pathID:[99,991,992,993]
			},
		},
		...video, //直播间
	]
};

export default broad;
